var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 915,
    viewBox: "0 0 1300 915",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1023.5 466C1023.5 567.068 944.569 649 847.204 649C749.838 649 684 567.068 684 466C684 364.932 749.838 283 847.204 283C944.569 283 1023.5 364.932 1023.5 466Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.703 467C509.703 547.634 444.022 613 362.999 613C281.977 613 276.703 547.634 276.703 467C276.703 386.366 281.977 321 362.999 321C444.022 321 509.703 386.366 509.703 467Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747 423C747 503.634 681.319 569 600.296 569C519.274 569 514 503.634 514 423C514 342.366 519.274 277 600.296 277C681.319 277 747 342.366 747 423Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_31_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M762.703 525C762.703 605.634 697.022 671 615.999 671C534.977 671 529.703 605.634 529.703 525C529.703 444.366 534.977 379 615.999 379C697.022 379 762.703 444.366 762.703 525Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_184",
    x: 407.6,
    y: 6.60001,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_184"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31_184",
    x: 0.303131,
    y: 44.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_184"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31_184",
    x: 237.6,
    y: 0.600006,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_184"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31_184",
    x: 253.303,
    y: 102.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_31_184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.67564d36ff33cd58a024508789869327.svg";
export { ForwardRef as ReactComponent };